
import { Component, OnInit } from '@angular/core';
import { MyDatePickerModule, IMyDpOptions } from 'mydatepicker';
import { CallBackEndService } from '../call-back-end.service';
import { timerComponent } from "../cheque-book-request/timerComponent";
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { Angular2CsvModule } from 'angular2-csv';
declare var getHexAscii: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import 'rxjs/Rx';
@Component({
  selector: 'app-cheque-stop-request',
  templateUrl: './cheque-stop-request.component.html',
  styleUrls: ['./cheque-stop-request.component.css']
})
export class ChequeStopRequestComponent implements OnInit {
  invalidOtp: string;
  ngOnInit(): void {
   
  }
  acctNo : string ='';
  acctNoBlank : string ='';
  desabled : boolean =false;
  chequeNo : string ='';
  chequeNoBlank : string ='';
  narration : string ='';
  narrationNoBlank : string ='';
  message : string ='';
  userName : string ='';
  custNo : string ='';
  stopPaymentResp : any;
  messageDiscription : string ='';
  chequeNoNoblank ; string ='';
  alltrue : string ='';
  chequeNoNoSpace : string='';
  chequeNoNumber : string ='';
  chequeNospecial : string ='';
  chequeNoZeroOnly : string ='';
  chequeNoSpace : string ='';
  chequebNumber : string ='';
  chequespecial : string ='';
  chequeZeroOnly : string ='';
  scoAccounts : any;
  otp : string;
  otpResponse : any;
  isLoad : boolean=false;
  storedOtp : string ;
  isShow : string ='show';
  notOTPTrue : string ;
  otpBlank : string ;
  disableNextBtn:Boolean=false;
  disableSubBtn:boolean=false;
  ditgreatnot : string='';

  reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regNum1 = /^[0-9]+$/;

  constructor(private webService: CallBackEndService,private timetStart : timerComponent,private spinnerService: Ng4LoadingSpinnerService) {
    this.scoAccounts=JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.userName=sessionStorage.getItem('storedUserName');
    this.custNo=sessionStorage.getItem('custNo');

  }
  stopPayment(){
    //this.timetStart.resetTimer();
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;

    // if(this.otp === undefined || this.otp === '')
    // {
    //   this.otpBlank='notOTPTrue';
    // }
    // else
    if(this.validateOtp()){
      this.message='';
      this.disableSubBtn=true;
       this.spinnerService.show();
      request.param1 = getHexAscii("",this.acctNo+this.chequeNo+this.custNo+this.narration+this.userName+ this.otp),
   // request.param1 = getHexAscii("",this.acctNo+this.chequeNo+this.custNo+this.narration),
     request.param2 = this.acctNo;
      request.param3 = this.chequeNo;
      request.param4 = this.custNo;
      request.param5 = this.narration;
      const otpDetails: any = {
        'userName': this.userName,
        'otp': getHexAscii("", this.otp),
      };
      request.param6 =otpDetails;
      this.webService.getResponse(request, 'stopCheque').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        this.stopPaymentResp=data;
        if (this.stopPaymentResp.status === 'S101'){
          alert('Malicious Request Detected');

        }
        if(this.stopPaymentResp.status==='S200'){

          this.message='success';
          this.messageDiscription=this.stopPaymentResp.param1;
          this.isShow='show2';
        }else{
          this.messageDiscription=this.stopPaymentResp.param1;
          this.message='error';
          this.disableSubBtn=false;
        }
      });
    }

  }


  changeValidateOtp(){
    this.invalidOtp = '';
    this.messageDiscription='';
  }
  validateOtp(){
    if (this.otp === undefined || this.otp === '') {
      this.invalidOtp = 'no';
     return false;
    }else if (this.otp.match(this.reg)) {
      this.invalidOtp = 'specialChar';
      return false;
    }else if (!this.otp.match(this.regNum1)) {
      this.invalidOtp = 'num';
      return false;
    } else if (this.otp.length!=6) {
      this.invalidOtp = 'len';
      return false;
    }else{
      this.invalidOtp = '';
      return true;
    }
  }
  messageForChequeNo()
  {
    var reg=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
    var regNum = /^[0-9]+$/;
    var regchar='/^[a-zA-Z]+$/';
    var regexpspace=/\s+/;
    var regZeroOnly='^[0][0]*[0]$';
    if(this.chequeNo===undefined || this.chequeNo==="")
    {
      this.chequeNoNoblank='no';
      this.alltrue='false';
      this.desabled=true;
    }
    else if(this.chequeNo===" " || this.chequeNo.indexOf(' ') !== -1)
    {
      this.chequeNoNoSpace='no';
      this.desabled=true;
    }
    else if(!this.chequeNo.match(regNum))
    {
      this.chequeNoNumber='no';
      this.desabled=true;
    }
    else if(this.chequeNo.match(reg))
    {
      this.chequeNospecial='no';
      this.desabled=true;
    }
    else if(this.chequeNo.match(regZeroOnly))
    {
      this.chequeNoZeroOnly='no';
      this.desabled=true;
    }
    else if(this.chequeNo.length>12)
    {
      this.ditgreatnot='no';
      this.desabled=true;
    }
  }
  removeChqueNoMessage()
  {
    this.chequeNoNoblank='';
    this.chequeNoNoSpace='';
    this.chequeNoNumber='';
    this.chequeNospecial='';
    this.chequeNoZeroOnly='';
    this.ditgreatnot='';
    this.chequeNoNoblank='';
    this.desabled=false;

  }
  removeNarrationNoMessage()
  {
    this.narrationNoBlank='';
    this.desabled=false;
  }
  removeAcctNoNoMessage()
  {
    this.acctNoBlank='';
    this.desabled=false;
  }
  getOtp()
  {
    // console.log("otp--");
    var reg=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
    var regNum = /^[0-9]+$/;
    var regchar='/^[a-zA-Z]+$/';
    var regexpspace=/\s+/;
    var regZeroOnly='^[0][0]*[0]$';

    if(this.acctNo===undefined || this.acctNo===''|| this.acctNo===' ')
    {
      this.acctNoBlank='no';

    }else  if(this.chequeNo===undefined || this.chequeNo==='')
    {
      this.chequeNoBlank='no';

    }else if(this.chequeNo===" " || this.chequeNo.indexOf(' ') !== -1)
    {
      this.chequeNoNoSpace='no';

    }
    else if(!this.chequeNo.match(regNum))
    {
      this.chequeNoNumber='no';

    }
    else if(this.chequeNo.match(reg))
    {
      this.chequeNospecial='no';

    }
    else if(this.chequeNo.match(regZeroOnly))
    {
      this.chequeNoZeroOnly='no';

    }else if(this.narration===undefined || this.narration==='' || this.narration==='  ')
    {
      this.narrationNoBlank='no';
    }
    else{
      this.disableNextBtn=true;
       this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      request.param1 = getHexAscii("",this.userName),
        request.param2 =this.userName;
      /*request.param3 = this.chequeNo;
      request.param4 = this.custNo;
      request.param5 = this.narration;
       const user: any = {
          'userName': this.userName,
    };
    request.param6=user;*/
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        this.otpResponse=data;
        this.isLoad=false;
        if (data.status === 'S101'){
          alert('Malicious Request Detected');
          this.disableNextBtn=false;
        }
        if(data.status==='S200'){
          // this.storedOtp=this.otpResponse.param1;
          this.otpResponse=data;
          // console.log('Otp :'+this.otpResponse.param1);
          this.isShow='show1';
        }
        else{
          this.disableNextBtn=false;
        }
      });

    }
  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/cheque-stop-request/cheque-stop-request.component.ts